module.exports = __webpack_public_path__ + "components/flag/static/square/bw-1cf0cc2837b5d8cb4f4ff79adc381ee2.svg";